import { Mail, MapPin, Phone } from "lucide-react";

const ITEMS = [
  {
    icon: Mail,
    label: "Email us",
    value: "support@tripzorentals.com",
    href: "mailto:support@tripzorentals.com",
    testId: "contact-email",
  },
  {
    icon: Phone,
    label: "Talk to us",
    value: "+91 96421 09642",
    href: "tel:+919642109642",
    testId: "contact-phone",
  },
  {
    icon: MapPin,
    label: "Headquarters",
    value: "Hyderabad · Telangana",
    href: null,
    testId: "contact-location",
  },
];

export const ContactSection = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative bg-[#1e2528] py-24 md:py-32 border-t border-[#3e4b55]/50 scroll-mt-24 md:scroll-mt-28"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-5">
            <div className="text-[10px] md:text-xs tracking-[0.3em] uppercase text-[#e89b1f] flex items-center gap-3 mb-6">
              <span className="inline-block w-8 h-px bg-[#e89b1f]" />
              Get in touch
            </div>
            <h2 className="font-display uppercase text-[#f7f7f7] text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
              Questions before
              <br />
              <span className="text-[#e89b1f]">we launch?</span>
            </h2>
            <p className="mt-6 text-[#e6ebed]/70 text-base md:text-lg font-light leading-relaxed max-w-md">
              Partnership, press, or just curious — we read every message.
            </p>
          </div>

          <div className="md:col-span-7 grid sm:grid-cols-3 gap-px bg-[#3e4b55]/60">
            {ITEMS.map((item) => {
              const Icon = item.icon;
              const inner = (
                <div className="flex flex-col h-full bg-[#1e2528] hover:bg-[#242c2f] transition-colors p-8 md:p-10 group">
                  <Icon
                    className="w-6 h-6 text-[#e89b1f] mb-6 group-hover:scale-110 transition-transform"
                    strokeWidth={1.6}
                  />
                  <div className="text-[10px] tracking-[0.3em] uppercase text-[#6f7c84] mb-3">
                    {item.label}
                  </div>
                  <div className="text-[#f7f7f7] text-base md:text-lg break-words">
                    {item.value}
                  </div>
                </div>
              );

              return item.href ? (
                <a
                  key={item.label}
                  data-testid={item.testId}
                  href={item.href}
                  className="block"
                >
                  {inner}
                </a>
              ) : (
                <div key={item.label} data-testid={item.testId}>
                  {inner}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
